import images from './images';

const wines = [
  {
    title: 'Jet Skiing ',
    price: '$50',
    tags: 'Bhimtal | Nainital',
  },
  {
    title: 'Parasailing',
    price: '$59',
    tags: 'Bhimtal | Nainital',
  },
  {
    title: 'Paddleboarding',
    price: '$44',
    tags: 'Bhimtal | Nainital',
  },
  {
    title: 'Waterskiing',
    price: '$31',
    tags: 'Nainital',
  },
  {
    title: 'swimming',
    price: '$26',
    tags: 'Nainital',
  },
];

const cocktails = [
  {
    title: 'Wakeboarding',
    price: '$20',
    tags: 'Nainital | Bhimtal',
  },
  {
    title: 'Surfing',
    price: '$16',
    tags: 'Bhimtal| Nainital',
  },
  {
    title: 'Bodyboarding',
    price: '$10',
    tags: 'Nainital',
  },
  {
    title: 'Scuba Diving',
    price: '$31',
    tags: 'Nainital |Bhimtal',
  },
  {
    title: 'Kayaking',
    price: '$26',
    tags: 'Bhimtal | Nainital',
  },
];

const awards = [
  {
    imgUrl: images.award01,
    title: 'Rising Star',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award02,
    title: 'Best location',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award03,
    title: 'Outstanding experience',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award05,
    title: 'AA Hospitality',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },

];

export default { wines, cocktails, awards };
